import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import ContactPage from "./pages/ContactPage";
import ComingSoon from "./pages/ComingSoon"; // Page de maintenance
import config from "./config"; // Import du fichier de configuration
import "./App.css";

function App() {
  // Vérifie si le site est en mode maintenance
  if (config.mode === "maintenance") {
    return <ComingSoon />;
  }

  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/contact" element={<ContactPage />} />
      </Routes>
    </Router>
  );
}

export default App;
